module.exports = __webpack_public_path__ + "sloth-9415a853f8.svg";